import React from 'react';
import Routes from './routes';

// FirebaseAppProvider
import { FirebaseAppProvider } from 'reactfire';
import firebaseConfig from './utils/firebaseConfig';
import { AuthProvider } from './Context/context';

function App() {
  return (
    <div className="App">
      <FirebaseAppProvider firebaseConfig={firebaseConfig}>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </FirebaseAppProvider>
    </div>
  );
}

export default App;
